import { render } from "./App.vue?vue&type=template&id=0f79f20d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0f79f20d&lang=css"
script.render = render

export default script